import * as React from 'react';
import clsx from 'clsx';

import { AutoScrollbars, Icons, Checkbox } from 'components';
import { getContainerIcon } from 'utils';

import { IContainer } from 'types/omjs/project';
import { IState } from 'services/root-reducer';
import i18next from 'i18next';
import './style.scss';

export interface IObjectGenPlanyInfoProps {
    className?: string;
    allContainers: IState['operations']['CONTAINERS']['data'];
    folderState: any;
    rootContainer: IContainer;
    onContainerExpand: (id: number, isChecked: boolean) => void;
    onSelectedChange: (id: number, isSelected: boolean) => void;
    currentZoom?: number;
}
export interface IObjectGenPlanyInfoState {}

export class ObjectGenPlanyInfoComponent extends React.Component<IObjectGenPlanyInfoProps, IObjectGenPlanyInfoState> {
    private wrapperRef = React.createRef<HTMLDivElement>();
    private scrollerRef = React.createRef<any>();

    constructor(props: IObjectGenPlanyInfoProps) {
        super(props);
    }

    renderChilds(parent: IContainer) {
        let { allContainers, folderState, currentZoom } = this.props;

        let childContainers = allContainers.filter(cont => cont.parent_id === parent.id);

        return (
            <ul
                className={clsx('container-items-box', {
                    'expanded': !!folderState[parent.id]
                })}
            >
                {childContainers.map(child => (
                    <li className="container-item" key={child.id}>
                        <div className="container-item__wrapper">
                            {child.type === 'folder' && (
                                <div
                                    className={clsx('container-item__expander', {
                                        'expanded': !!folderState[child.id]
                                    })}
                                    onClick={() => {
                                        this.props.onContainerExpand(child.id, !folderState[child.id]);
                                    }}
                                >
                                    <Icons.ArrowLiteIcon />
                                </div>
                            )}
                            <label key={child.id} className="container-item__label">
                                <Checkbox
                                    disabled={currentZoom < 12}
                                    checked={child.selected}
                                    onChange={() => {
                                        this.props.onSelectedChange(child.id, !child.selected);
                                    }}
                                />
                                {child.type !== 'folder' && (
                                    <div className="container-item__icon-wrapper">
                                        <img
                                            className="container-item__icon"
                                            src={getContainerIcon(child)}
                                            alt=""
                                        />
                                    </div>
                                )}
                                <div className="container-item__text">
                                    {child.name}
                                </div>
                                {child.objectsCount !== false && (
                                    <div
                                        className={clsx('container-item__count', {
                                            'not-visible': !child.selected
                                        })}
                                    >
                                        {child.objectsCount}
                                    </div>
                                )}
                            </label>
                        </div>
                        {child.type === 'folder' && this.renderChilds(child)}
                    </li>
                ))}
            </ul>
        );
    }

    render() {
        let { rootContainer } = this.props;

        return (
            <div className="section-object-info-scroll-fix">
                <AutoScrollbars className={this.props.className} ref={this.scrollerRef}>
                    <div className='section-object-info gen-plany-object-info' ref={this.wrapperRef}>
                        { this.renderChilds(rootContainer) }
                    </div>
                </AutoScrollbars>
            </div>
        );
    }
}

export const ObjectGenPlanyInfo = ObjectGenPlanyInfoComponent;
